// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';
import {useNavigate} from "react-router-dom";

const WatchPurchaseGrid4 = () => {
  const watchBrands = [
    {
      name: "Penkala i hemijske olovke luksuznih brendova",
      image: "assets/images/penkalo.webp",
      models: ["Montblanc, Parker, Waterman, Cartier..."]
    },
    {
      name: "Luksuzna i kolekcionarska naliv-pera",
      image: "assets/images/nalivpero.avif",
      models: [""]
    },
    {
      name: "Upaljače poznatih brendova",
      image: "assets/images/dunpont.webp",
      models: ["Dunhill, Cartier, Dupont, Zippo – posebno limitirane serije"]
    }
  ];

  const navigate = useNavigate();

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>✒ Penkala i upaljače</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <span>{model}</span>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid4;